export const vacancyCategoryData = [
  {
    id: 1,
    name: "None",
  },
  {
    id: 2,
    name: "Helper",
    children: [
      {
        id: 3,
        name: "Cylindrical Lathe",
      },
      {
        id: 4,
        name: "VTL",
      },
      {
        id: 5,
        name: "Drilling",
      },
      {
        id: 6,
        name: "Shaping",
      },
      {
        id: 7,
        name: "Milling",
      },
      {
        id: 8,
        name: "Boring",
      },
      {
        id: 9,
        name: "Plano miller",
      },
      {
        id: 10,
        name: "VMC",
      },
      {
        id: 11,
        name: "CNC",
      },
      {
        id: 12,
        name: "Honning",
      },
    ],
  },
  {
    id: 13,
    name: "Fitter",
  },
  {
    id: 14,
    name: "Welder",
    children: [
      {
        id: 15,
        name: "Argen",
      },
      {
        id: 16,
        name: "Gas",
      },
      {
        id: 17,
        name: "Mig",
      },
      {
        id: 18,
        name: "Spot",
      },
      {
        id: 19,
        name: "Arc",
      },
    ],
  },
  {
    id: 20,
    name: "Operator",
    children: [
      {
        id: 21,
        name: "Cylindrical Lathe",
      },
      {
        id: 22,
        name: "VTL",
      },
      {
        id: 23,
        name: "Surface grinding",
      },
      {
        id: 24,
        name: "Centerless grinding",
      },
      {
        id: 25,
        name: "Cylindrical grinding",
      },
      {
        id: 26,
        name: "Polishing",
      },
      {
        id: 27,
        name: "Wire cut",
      },
      {
        id: 28,
        name: "EDM/Spark",
      },
      {
        id: 29,
        name: "Radial Drilling",
      },
      {
        id: 30,
        name: "Tapping",
      },
      {
        id: 31,
        name: "DRO milling",
      },
      {
        id: 32,
        name: "Conventional milling",
      },
      {
        id: 33,
        name: "Table Boring",
      },
      {
        id: 34,
        name: "Floor Boring",
      },
      {
        id: 35,
        name: "CNC Lathe",
      },
      {
        id: 36,
        name: "CNC VTL",
      },
      {
        id: 37,
        name: "VMC",
      },
      {
        id: 38,
        name: "VMC",
        children: [
          {
            id: 39,
            name: "3 Axis",
          },
          {
            id: 40,
            name: "4 Axis",
          },
          {
            id: 41,
            name: "5 Axis",
          },
        ],
      },
      {
        id: 42,
        name: "Turn mill",
      },
      {
        id: 43,
        name: "Honning",
      },
      {
        id: 44,
        name: "Broaching",
      },
      {
        id: 45,
        name: "Deep Hole",
      },
      {
        id: 46,
        name: "Waterjet",
      },
      {
        id: 47,
        name: "Shapping",
      },
      {
        id: 48,
        name: "Planing",
      },
      {
        id: 49,
        name: "Gear shaper",
      },
      {
        id: 50,
        name: "Tool and Cutter",
      },
      {
        id: 51,
        name: "Laser cutting",
      },
      {
        id: 52,
        name: "Plano miller",
      },
      {
        id: 53,
        name: "Hobbing",
      },
      {
        id: 54,
        name: "Trob operator",
      },
      {
        id: 55,
        name: "Band saw",
      },
      {
        id: 56,
        name: "Profile projector",
      },
      {
        id: 57,
        name: "Lapping",
      },
      {
        id: 58,
        name: "Sheet Cutting",
      },
      {
        id: 59,
        name: "Bending",
        children: [
          {
            id: 60,
            name: "CNC",
          },
          {
            id: 61,
            name: "Conventional",
          },
        ],
      },
      {
        id: 62,
        name: "Hydraulic press",
        children: [
          {
            id: 63,
            name: "Manual",
          },
          {
            id: 64,
            name: "CNC",
          },
        ],
      },
      {
        id: 65,
        name: "Gas Cutting",
      },
    ],
  },
  {
    id: 66,
    name: "Programmers",
    children: [
      {
        id: 67,
        name: "CNC",
      },
      {
        id: 68,
        name: "VMC",
        children: [
          {
            id: 69,
            name: "2D",
          },
          {
            id: 70,
            name: "3D",
          },
        ],
      },
      {
        id: 71,
        name: "CNC Cutting",
      },
      {
        id: 72,
        name: "CNC Bending",
      },
    ],
  },
  {
    id: "Designer",
    name: "Designer",
    children: [
      {
        id: "AutoCad",
        name: "AutoCad",
      },
      {
        id: "Master Cam",
        name: "Master Cam",
      },
      {
        id: "Solid Edge",
        name: "Solid Edge",
      },
      {
        id: "Solid Works",
        name: "Solid Works",
      },
      {
        id: "ProvE",
        name: "ProvE",
      },
      {
        id: "Catia",
        name: "Catia",
      },
      {
        id: "Unigraphics",
        name: "Unigraphics",
      },
      {
        id: "Delcam",
        name: "Delcam",
      },
      {
        id: "Edgecam",
        name: "Edgecam",
      },
    ],
  },
  {
    id: 73,
    name: "Engineer",
    children: [
      {
        id: 74,
        name: "QC Engineer",
        children: [
          {
            id: 75,
            name: "CMM",
          },
          {
            id: 76,
            name: "Trimos",
          },
          {
            id: 77,
            name: "QC",
          },
        ],
      },
      {
        id: 78,
        name: "Sales Engineer",
        children: [
          {
            id: 79,
            name: "Cutting Tools",
          },
          {
            id: 80,
            name: "Hand Tools",
          },
          {
            id: 81,
            name: "Cutting Oil",
          },
          {
            id: 82,
            name: "Machine Tool",
          },
          {
            id: 83,
            name: "Instrument",
          },
          {
            id: 84,
            name: "Software",
          },
        ],
      },
      {
        id: 85,
        name: "Sevice Engineer",
        children: [
          {
            id: 86,
            name: "Machine",
          },
          {
            id: 87,
            name: "Instrument",
          },
          {
            id: 88,
            name: "Crane/hoist",
          },
        ],
      },
      {
        id: 89,
        name: "Production Engineer",
        children: [
          {
            id: 90,
            name: "Machine Shop",
          },
          {
            id: 91,
            name: "Fabrication Shop",
          },
        ],
      },
      {
        id: 92,
        name: "Purchase Engineer",
      },
    ],
  },
  {
    id: 93,
    name: "Others",
  },
];
